import { Input } from '../ui/input';
import { Label } from '../ui/label';
import { Button } from '../ui/button';
import { useLanguage } from '../../contexts/LanguageContext';

const fieldClass = 'border-2 border-primary focus:border-primary focus:ring-primary cream-bg';

export const AdditionalGuestFields = ({ guest, index, onChange, onRemove }) => {
  const { t } = useLanguage();

  return (
    <div className="space-y-4 border-t-2 border-primary pt-6" data-testid={`additional-guest-${index}`}>
      <div className="flex items-center justify-between">
        <h3 className="font-serif text-lg font-semibold blue-text">
          {t('rsvp.guestNumber')} {index + 2} {t('rsvp.information')}
        </h3>
        <Button
          type="button"
          variant="outline"
          size="sm"
          onClick={() => onRemove(index)}
          className="border-2 border-red-500 text-red-600 hover:bg-red-50"
          data-testid={`remove-guest-${index}`}
        >
          {t('rsvp.remove')}
        </Button>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div className="space-y-2">
          <Label htmlFor={`guest-${index}-firstName`} className="font-sans font-medium blue-text">
            {t('rsvp.firstName')} *
          </Label>
          <Input
            id={`guest-${index}-firstName`}
            autoComplete="given-name"
            required
            value={guest.firstName}
            onChange={(e) => onChange(index, 'firstName', e.target.value)}
            className={fieldClass}
            placeholder={t('rsvp.firstName')}
          />
        </div>
        <div className="space-y-2">
          <Label htmlFor={`guest-${index}-lastName`} className="font-sans font-medium blue-text">
            {t('rsvp.lastName')} *
          </Label>
          <Input
            id={`guest-${index}-lastName`}
            autoComplete="family-name"
            required
            value={guest.lastName}
            onChange={(e) => onChange(index, 'lastName', e.target.value)}
            className={fieldClass}
            placeholder={t('rsvp.lastName')}
          />
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div className="space-y-2">
          <Label htmlFor={`guest-${index}-email`} className="font-sans font-medium blue-text">
            {t('rsvp.email')} *
          </Label>
          <Input
            id={`guest-${index}-email`}
            type="email"
            autoComplete="email"
            required
            value={guest.email}
            onChange={(e) => onChange(index, 'email', e.target.value)}
            className={fieldClass}
            placeholder={t('rsvp.email')}
          />
        </div>
        <div className="space-y-2">
          <Label htmlFor={`guest-${index}-phone`} className="font-sans font-medium blue-text">
            {t('rsvp.phone')}
          </Label>
          <Input
            id={`guest-${index}-phone`}
            type="tel"
            autoComplete="tel"
            value={guest.phone}
            onChange={(e) => onChange(index, 'phone', e.target.value)}
            className={fieldClass}
            placeholder="+1 (555) 000-0000"
          />
        </div>
      </div>
    </div>
  );
};
